import Joi from "joi-browser";

function errorsAsString(errors) {
    const err = errors[0];
    let strError = "";
    switch (err.type) {
        case "required":
            strError = "is required";
            break;
        case "object.base":
            strError = "is required";
            break;
    }
    return {
        template: " {{message}}",
        context: {
            errors: errors.length,
            message: strError,
        },
    };
}

const ReviewProductForm = Joi.object({
    publishedModelId: Joi.string(),
    selection: Joi.object()
        .required()
        .error((errors) => {
            return errorsAsString(errors);
        }),
    comment: Joi.when(Joi.ref("$isAccepted"), {
        is: false,
        then: Joi.string().required(),
    }),
});

export default { ReviewProductForm };
